export const mutations = {
    recaptchaLoaded(state) {
        state.recaptchaLoaded = true;
    }
}
